import {
	GET_SITE_REPORT,
	GET_SITE_LIST,
	SET_SELECTED_SITE
} from '../actions/SiteReportActions';

const initialState = {
	siteReport: [],
	siteList: [],
	selectedSite: ''
};

const siteReportReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_SITE_REPORT: {
						return {
							...state,
							siteReport: action.siteReport
						};
					}
					case GET_SITE_LIST: {
						return {
							...state,
							siteList: action.siteList
						};
					}
					case SET_SELECTED_SITE: {
						return {
							...state,
							selectedSite: action.selectedSite
						};
					}
					default: {
						return state;
					}
	}
};

export default siteReportReducer;
